import rotinasInventario from "~/composables/menus/rotinas/inventario/rotinas";

export default function () {
	return rotinasInventario;
}
